import { formatDecimalPounds } from './formatDecimalPounds';
import { SUB_PENNY_EXCESS } from './invoiceBalance';
import type { TopUpPosting } from '../types/agreements.types';

export const CHOOSE_FUNDING_REASON = 'Choose how this will be covered.';
export const TOP_UP_REQUIRED_REASON = 'Record the payment the customer made, or load the excess into arrears.';
export const CHOOSE_DEALER_FIRST_REASON =
    'Choose the invoicing dealer at the top of this panel before recording the payment.';
export const TOP_UP_POSTING_REASON = 'Waiting for the payment to reach the account balance.';
export const TOP_UP_DELAYED_REASON =
    'The payment has not reached the account balance yet. Load the excess into arrears to submit now.';
export const TOP_UP_STILL_SHORT_REASON =
    'This invoice is still over the account balance. Record a further payment or load the excess into arrears.';

export function topUpNotice(recordedAmount: string | null, posting: TopUpPosting): string | null {
    if (recordedAmount === null) return null;
    const recorded = `Payment of ${formatDecimalPounds(recordedAmount)} recorded.`;
    if (posting === 'posting') return `${recorded} Updating the account balance.`;
    if (posting === 'timedOut') {
        return `${recorded} The account balance will update shortly; you can load the excess into arrears instead.`;
    }
    return `Payment of ${formatDecimalPounds(recordedAmount)} added to the account balance.`;
}

export function topUpChosenReason(recordedAmount: string | null, posting: TopUpPosting): string {
    if (recordedAmount === null) return TOP_UP_REQUIRED_REASON;
    if (posting === 'posting') return TOP_UP_POSTING_REASON;
    if (posting === 'timedOut') return TOP_UP_DELAYED_REASON;
    return TOP_UP_STILL_SHORT_REASON;
}

export function fundingQuestion(excess: string): string {
    return excess === SUB_PENNY_EXCESS ? 'How will this be covered?' : `How will the ${excess} be covered?`;
}
